import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { LoggingService } from '@core/services/logging.service';

@Injectable()
export class MonitoringErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: any): void {
    const monitoringService = this.injector.get(LoggingService);
    monitoringService.logError(error);
    super.handleError(error);
  }
}
